export function timeAgo(date: Date): string {
	const diff = Date.now() - date.getTime();
	const minutes = Math.floor(diff / 60000);
	if (minutes < 60) return `${minutes} minutes ago`;
	const hours = Math.floor(minutes / 60);
	if (hours < 24) return `${hours} hours ago`;
	const days = Math.floor(hours / 24);
	return `${days} days ago`;
}

/** "eggs, milk\nrice" → ['eggs', 'milk', 'rice'] */
export function parseIngredientList(text: string): string[] {
	return text.split(/[,\n]/).map((s) => s.trim()).filter(Boolean);
}
